import { api } from './api'

export interface Calendario {
  id_calendario: number
  nome_calendario: string
  descricao_calendario: string
  data_cadastro: string
  id_file: number
  ano: number
  periodo: number
  id_tipo_calendario: number
  vigente: number
  createdAt: string
  updatedAt: string
}

export interface CreateCalendarioData {
  nome_calendario: string
  descricao_calendario: string
  periodo: number
  ano: number
  id_tipo_calendario: number
  vigente: number
  file: File
}

export interface UpdateCalendarioData {
  id_calendario: number
  nome_calendario: string
  descricao_calendario: string
  periodo: number
  ano: number
  id_tipo_calendario: number
  vigente: number
}

export const calendarioService = {
  async getAll() {
    try {
      const response = await api.get('/get-calendarios')
      return {
        success: true,
        data: response.data.calendarios || []
      }
    } catch (error: any) {
      console.error('Erro ao buscar calendários:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao carregar calendários'
      }
    }
  },

  async getById(id: number) {
    try {
      const response = await api.get(`/get-calendario/${id}`)
      return {
        success: true,
        data: response.data.calendario
      }
    } catch (error: any) {
      console.error('Erro ao buscar calendário:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao carregar calendário'
      }
    }
  },

  async create(data: CreateCalendarioData) {
    try {
      const formData = new FormData()
      formData.append('nome_calendario', data.nome_calendario)
      formData.append('descricao_calendario', data.descricao_calendario)
      formData.append('periodo', data.periodo.toString())
      formData.append('ano', data.ano.toString())
      formData.append('id_tipo_calendario', data.id_tipo_calendario.toString() || '1')
      formData.append('vigente', data.vigente.toString())
      formData.append('file', data.file)

      const response = await api.post('/create-calendario', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      
      return {
        success: true,
        data: response.data.calendario
      }
    } catch (error: any) {
      console.error('Erro ao criar calendário:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao criar calendário'
      }
    }
  },

  async update(data: UpdateCalendarioData) {
    try {
      const response = await api.put('/update-calendario', data)
      return {
        success: true,
        data: response.data.calendario
      }
    } catch (error: any) {
      console.error('Erro ao atualizar calendário:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao atualizar calendário'
      }
    }
  },

  async delete(id: number) {
    try {
      await api.delete(`/delete-calendario/${id}`)
      return {
        success: true
      }
    } catch (error: any) {
      console.error('Erro ao deletar calendário:', error)
      return {
        success: false,
        error: error.response?.data?.message || 'Erro ao deletar calendário'
      }
    }
  }
}
